<template lang="pug">
  .row(data-testid="social-view")
    .form-group.col-md-6
      label Twitter ID
      p(v-if="value.twitter_id")
        i.fa.fa-fw.fa-twitter.text-light-blue
        |
        |
        a(:href="value.twitter_url" target="_blank" data-testid="-link-twitter-id")
          | {{value.twitter_id}}
          |
          |
          i.fa.fa-external-link
      p(v-else) {{app_lang.NO_INPUT}}

    .form-group.col-md-6
      label ブログURL
      p(v-if="value.blog_url")
        i.fa.fa-fw.fa-globe
        |
        |
        a(:href="value.valid_blog_url" target="_blank" data-testid="-link-blog-url")
          | {{value.blog_url}}
          |
          |
          i.fa.fa-external-link
      p(v-else) {{app_lang.NO_INPUT}}

</template>

<script>
export default {
  name: 'SocialView',
  props: {
    /**
     * ソーシャルサイト { twitter_id, blog_url }
     */
    value: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/molecules/SocialView.vue